/**
 * useCheckpointsBipagem — Set com os códigos das etapas-checkpoint de
 * bipagem (Lote B — §2.5, chave `checkpoints_bipagem` da Config).
 *
 * Lote D: delega a leitura ao useConfigProducao (fetch único + cache do
 * catálogo compartilhado com os demais consumidores). A degradação em
 * camadas se preserva: sem `ppcp:view`, catálogo sem a chave ou request
 * falho -> default do catálogo (Usinagem + Separação).
 *
 * O gate REAL é o guard do service no backend (400 em concluir manual de
 * checkpoint) — este hook é UX: esconder botão/modal de quem não deve ver.
 */
import { useMemo } from "react";

import {
  CHAVE_CHECKPOINTS_BIPAGEM,
  DEFAULT_CHECKPOINTS_BIPAGEM,
} from "../../../services/producaoV2";
import { useConfigProducao } from "./useConfigProducao";

export function useCheckpointsBipagem() {
  const { valorDe } = useConfigProducao();

  return useMemo(() => {
    const valor = valorDe(CHAVE_CHECKPOINTS_BIPAGEM, null);
    const codigos = Array.isArray(valor) ? valor : DEFAULT_CHECKPOINTS_BIPAGEM;
    return new Set(codigos.map((c) => String(c).toUpperCase()));
  }, [valorDe]);
}
